import { TransferBaseModel } from '../transfer-base.model';
import { EntityTypeLookup } from './account';

export interface Contact extends TransferBaseModel {
    id?: string;
    is_primary?: boolean;
    email?: string;
    title?: string;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    role_lookup?: string;
    person_account?: PersonAccount;
    accounts_linked?: AccountsLinked[];
    accounts_unlink?: AccountsLinked[];
    users_linked?: UserLinked[];
    users_unlink?: UserLinked[];
    detail?: ContactDetail;
    compliance?: ContactCompliance;
    created_date?: Date;
    contact_quiz?: ContactQuiz[];
    contact_address?: ContactAddress[];
    contact_questionnaire?: ContactQuiz[];
    marketing?: ContactMarketing;
    dirty?: boolean;
}

export interface PersonAccount {
    name?: string;
    tenant?: string;
    acknowledge_risks?: boolean;
    acknowledge_risks_date?: Date;
}

// Generated by https://quicktype.io

export interface UserLinked {
    id: string;
    email?: string;
}


export interface AccountsLinked {
    id?: string;
    is_primary?: boolean;
    entity_type_lookup?: EntityTypeLookup;
}

export interface ContactCompliance {
    country_of_tax_residence_lookup?: string;
    tax_identification_number?: string;
    tax_id_exempt_reason_lookup?: string;
    tax_identification_number_type_lookup?: string;
    id3_verified?: boolean;
    id3_message?: string;
    id3_status_lookup?: string;
    quiz_required?: boolean;
    assessment_result?: string;
    quiz_completed?: boolean;
    quiz_completed_date?: Date;
    legal_agreed?: boolean;
    legal_agreed_date?: Date;
    acknowledge_risks?: boolean;
    acknowledge_risks_date?: Date;
    GDPR?: boolean;
    opt_in_agreed_date?: Date;
    ib_remuneration_agreement_accepted?: boolean;
    ib_remuneration_agreement_accepted_date?: Date;
}

export interface ContactAddress {
    address_line1?: string;
    address_line2?: string;
    address_city?: string;
    address_postcode?: string;
    address_state?: string;
    address_country_lookup?: string;
    address_years?: number;
    address_months?: number;
    is_current_address?: boolean;
    is_mailing_address?: boolean;
    is_shipping_address?: boolean;
    is_other_address?: boolean;
    time_at_current_address_lookup?: string;
}

export interface ContactQuiz {
    sat_array_contact_quiz_id?: string;
    question?: string;
    question_code?: string;
    question_sub?: string;
    answer?: string;
    score?: number;
}

export interface ContactDetail {
    date_of_birth?: Date;
    place_of_birth?: string;
    register_ip?: string;
    register_date?: Date;
    do_not_call?: boolean;
    phone_mobile?: string;
    phone_home?: string;
    phone_work?: string;
    phone_other?: string;
    annual_income_lookup?: string;
    crm_id?: string;
    crm_url?: string;
    nationality?: string;
    industry?: string;
    occupation?: string;
    employment_status?: string;
    previous_industry?: string;
    previous_occupation?: string;
    anticipated_initial_deposit?: string;
    investment_objective?: string;
    liquid_net_worth?: string;
    source_of_funds?: string;
    other_source_of_funds?: string;
    referral_description?: string;
    skrill_customer_id?: string;
    secondary_email?: string;
    suppress_transactional_email?: boolean;
    fax?: string;
    gender_lookup?: string;
    estimated_net_worth?: string;
    years_experience?: number;
    opted_out_email?: boolean;
    opted_out_fax?: boolean;
    opted_out_sms?: boolean;
}

// Generated by https://quicktype.io

export interface ContactCRMInfo {
    id_account_ind: string;
    crm_id_account_ind: string;
    crm_id_application_ind: string;
}

// Generated by https://quicktype.io

export interface ContactAqAttempt {
    application_crm_id: string;
    attempt_number_c: number;
    currency_iso_code: string;
    outcome_c: string;
    question_text: string;
    answer: string;
    outcome: string;
}

export interface ContactMarketing {
    source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
    gclid?: string;
    fbclid?: string;
}
